<ul class="nav nav-tabs list-map">
    <li role="presentation" routerLinkActive="active" class="active">
        <a data-cy="list" [routerLink]="['.']" [queryParams]="{'display': 'list'}" queryParamsHandling="merge">List</a>
    </li>
    <li role="presentation" routerLinkActive="active">
        <a data-cy="map" [routerLink]="['.']" [queryParams]="{'display': 'map'}" queryParamsHandling="merge">Map</a>
    </li>
</ul>
<div class="result-container">
    <app-gps-logs *ngIf="display=='list'" [gpsLogDateGroups]="searchService.gpsLogDateGroups" [gpsLogsResponse]="searchService.gpsLogsResponse"></app-gps-logs>

    <div *ngIf="display=='map'">

        <div class="row">
            <div class="col-md-3 col-md-offset-9">
                <div class="btn-group select-site" dropdown>
                    <button class="btn btn-default dropdown-toggle fill" [disabled]="disabled" dropdownToggle type="button">
                        <span data-cy="select-date" *ngIf="!selectedDateGroup">Select Date</span>
                        <span *ngIf="selectedDateGroup">
                            Date {{ selectedDateGroup.date | appDateFromConfig: 'dateFormatMedium' }}
                        </span>
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" *dropdownMenu role="menu">
                        <li *ngFor="let grp of searchService.gpsLogDateGroups">
                            <a class="dropdown-item" (click)="selectDateGroup(grp)">
                                {{ grp.date | appDateFromConfig: 'dateFormatMedium' }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div data-cy="map-image" class="leaflet-panel" leaflet [leafletOptions]="options" [leafletLayers]="layers" [leafletFitBounds]="fitBounds">
        </div>
    </div>
</div>
